import { loadFile } from 'utils';

const downloadJS = (window as any).download;

const downloadUrlUsingAnchor = (url: string, filename?: string) => {
  const a = document.createElement('a');
  a.style.display = 'none';
  document.body.appendChild(a);
  a.href = url;
  a.download = filename || 'download';
  a.click();
  document.body.removeChild(a);
};

export const download = (
  urlOrBlob: string | Blob,
  filename?: string,
  mimeType?: string
) => {
  const { beatflyerTheme, beatflyerPlatform } = window as any;
  if (beatflyerPlatform === 'sketch') {
    loadFile(urlOrBlob as string)
      .then((blob: Blob) => {
        const file = new File([blob], filename || 'Untitled');
        window.top?.postMessage(file, '*');
      })
      .catch(e => {
        console.log(e);
      });
  } else if (beatflyerTheme === 'adobe') {
    window.top?.postMessage(
      {
        type: 'download',
        url: urlOrBlob,
        filename
      },
      '*'
    );
    return;
  }
  if (typeof urlOrBlob === 'string') {
    if (
      urlOrBlob.startsWith('https://s3-eu-west-1.amazonaws.com/beatflyer-test/')
    ) {
      // external domain, will use original file name
      downloadJS(urlOrBlob);
    } else {
      downloadUrlUsingAnchor(urlOrBlob, filename);
    }
  } else {
    downloadJS(urlOrBlob, filename, mimeType);
  }
};



// WEBPACK FOOTER //
// ./src/utils/Download.ts